import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/endpoints';

export const contactService = {
  sendContactRequest: async (data) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SEND_SMS, {
        name: data.name,
        phone: data.phone,
        email: data.email,
        projectDescription: data.projectDescription,
        recaptcha: data.recaptcha,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to send message. Please try again.',
      };
    }
  },

  sendChatRequest: async (data) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.SEND_SMS, {
        name: data.name,
        phone: data.phone,
        email: data.email,
        projectDescription: data.projectDescription,
        recaptcha: data.recaptcha,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to send chat request. Please try again.',
      };
    }
  },
};

export default contactService;
